"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var API_ = function API_(name) {
  return {
    REQUEST: name + "_REQUEST",
    SUCCESS: name + "_SUCCESS",
    FAILURE: name + "_FAILURE"
  };
};

exports.PAGINATE_ = function (name) {
  return __assign({
    INIT: "PAGINATE_" + name + "_INIT",
    NEXT_PAGE: "PAGINATE_" + name + "_NEXT_PAGE",
    PREV_PAGE: "PAGINATE_" + name + "_PREV_PAGE",
    GO_TO_PAGE: "PAGINATE_" + name + "_GO_TO_PAGE",
    UPDATE_CRITERIA: "PAGINATE_" + name + "_UPDATE_CRITERIA",
    SORT: "PAGINATE_" + name + "_SORT"
  }, API_("PAGINATE_" + name));
};

var PaginateAction =
/** @class */
function () {
  function PaginateAction(name, action) {
    var _this = this;

    this.name = name;
    this.action = action;

    this.nextPage = function () {
      return function (dispatch, getState) {
        dispatch({
          type: exports.PAGINATE_(_this.name).NEXT_PAGE
        });
        return _this.fetch(dispatch, getState);
      };
    };

    this.prevPage = function () {
      return function (dispatch, getState) {
        dispatch({
          type: exports.PAGINATE_(_this.name).PREV_PAGE
        });
        return _this.fetch(dispatch, getState);
      };
    };

    this.goToPage = function (pageNumber) {
      return function (dispatch, getState) {
        dispatch({
          type: exports.PAGINATE_(_this.name).GO_TO_PAGE,
          pageNumber: pageNumber
        });
        return _this.fetch(dispatch, getState);
      };
    };

    this.sort = function (sortBy, orderBy) {
      return function (dispatch, getState) {
        dispatch({
          type: exports.PAGINATE_(_this.name).SORT,
          sortBy: sortBy,
          orderBy: orderBy
        });
        return _this.fetch(dispatch, getState);
      };
    };

    this.updateCriteria = function (name, value) {
      return function (dispatch, getState) {
        dispatch({
          type: exports.PAGINATE_(_this.name).UPDATE_CRITERIA,
          name: name,
          value: value
        });
        return _this.fetch(dispatch, getState);
      };
    };
  }

  PaginateAction.prototype.fetch = function (dispatch, getState) {
    return this.action(this.getState(getState).criteria)(dispatch, getState);
  };

  PaginateAction.prototype.getState = function (getState) {
    return getState().paginate[this.name];
  };

  return PaginateAction;
}();

exports.PaginateAction = PaginateAction;